import {IMembersFormatFilter} from '@hooks';
import {useMemo} from 'react';
import {IOptions} from '../components/values-themes-filter';
import {useStoreContext} from '@store/store-context';
import {FeedbackController} from '../feedback-controller';
import {FeedbackRequestImpl} from '../feedback-requests';
import {useState} from 'react';
import {toInclusiveFeedbackEndDate} from '../feedback-date.utils';
import {allTimeFeedbackRange} from '../feedback-date-range';

export const useFeedbackWrittenHook = () => {
  const {
    authStore: {auth},
  } = useStoreContext();

  const [userFilter, setUserFilter] = useState({
    filterBy: {
      label: 'Teams',
      value: 'team',
    },
    selectedTeam: {
      value: auth.user.id,
      label: 'My Team',
    },
    members: [] as Array<IMembersFormatFilter>,
  });

  const [sortBy, setSortBy] = useState('desc');

  const [valueThemeFilter, setValueThemeFilter] = useState<IOptions>({
    filterBy: '',
    theme: '',
    value: '',
  });

  const [dateRange, setDateRange] = useState(allTimeFeedbackRange);

  const request = useMemo(() => new FeedbackRequestImpl(), []);
  const controller = useMemo(() => new FeedbackController(request), [request]);

  const filters = useMemo(() => {
    return {
      paginate: false,
      startDate: dateRange.starts || undefined,
      endDate: dateRange.ends
        ? toInclusiveFeedbackEndDate(dateRange.ends)
        : undefined,
      values: valueThemeFilter.value,
      impression: valueThemeFilter.theme,
      sortBy: `createdAt:${sortBy}`,
      reviewer: auth.user.id || undefined,
    };
  }, [
    dateRange.starts,
    dateRange.ends,
    valueThemeFilter.value,
    sortBy,
    valueThemeFilter.theme,
    auth.user.id,
  ]);
  return {
    userFilter,
    setUserFilter,
    controller,
    filters,
    sortBy,
    setSortBy,
    dateRange,
    setDateRange,
    valueThemeFilter,
    setValueThemeFilter,
  };
};
